export default __webpack_public_path__ + "img/ff7d6faef6be279743c464fd6527d508.svg";